module.exports = "/public/images/fabc96c7dd7c72eef4c8c90e6b7dc3c3.png";